import scrollToElement from './functions/scrollToElement';
import ToggleTermExtraInfo from './functions/toggle-term-extra-info';
import initializeAjaxForms from './modules/ajax-forms';
import checkAllAgreements from './modules/form-check-all';
import ProductQuantity from './modules/product-quantity';
import ProductsWishlist from './modules/products-wishlist';
import RequestOfferWishlist from './modules/request-offer-wishlist';
import ProductBrandSelector from './modules/select-brand';

var documentReady = function () {
    ProductBrandSelector();
    if (document.getElementById('scrollDown')) {
        document.getElementById('scrollDown').addEventListener('click', () => {
            scrollToElement('.product-brands');
        });
    }
    document.querySelectorAll('#scrollToProducts').forEach(button => {
        button.addEventListener('click', () => {
            scrollToElement('.products-categories');
        });
    });
    initializeAjaxForms();
    ProductQuantity();
    ProductsWishlist();
    RequestOfferWishlist();
    checkAllAgreements();
    ToggleTermExtraInfo();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
